<template>
  <side :nav="nav"></side>
</template>

<script>
import side from "../side";
export default {
  data() {
    return {
      nav: [
        { name: "按资源统计", url: "statisticsResources" },
        { name: "按个人统计", url: "statisticsPeople" },
        { name: "按校区统计", url: "statisticsSchool" },
        { name: "打印统计", url: "statisticsPrint" },
      ],
    };
  },
  components: { side },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/statistics/index.vue